import { getConfig } from '../RD2ClientConfig';

const initialState = { config: getConfig() };

export default function reducer(state = initialState, action) {
	return { config: state.config };
};